module.exports = __webpack_public_path__ + "assets/img/Dover MRT.a1ed7a78.jpg";